import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { AppRouter } from "src/App";
import { withIsLoadingAtom } from "src/common/pipes";
import { IRestorePassword } from "src/pages/Authentificate/RestorePwdPage/RestorePwdPage";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { toastHandler } from "src/util";

export const restorePasswordRequest = reatomAsync(
  (_ctx, dto: IRestorePassword) => {
    return API.authApi.authControllerChangePasswordRequest(dto.email);
  },
  "restorePasswordRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());

restorePasswordRequest.onFulfill.onCall(() => {
  AppRouter.navigate(RoutesPaths.AUTH.LOGIN, { replace: true });
  toastHandler.success({
    name: "restoreSended",
    title: "Письмо отправлено",
    content: "Для восстановления доступа следуйте инструкции в письме",
  });
});
